import { useLoader } from '@react-three/fiber'
import { EffectComposer, SSR, Bloom, LUT, DepthOfField } from '@react-three/postprocessing'
import { LUTCubeLoader } from 'postprocessing'

export function Effects() {
  const texture = useLoader(LUTCubeLoader, '/F-6800-STD.cube')

  const { enabled, ...props } = {
    enabled: true,
    temporalResolve: false,
    STRETCH_MISSED_RAYS: true,
    USE_MRT: false,
    USE_NORMALMAP: false,
    USE_ROUGHNESSMAP: false,
    // ENABLE_JITTERING: true,
    ENABLE_BLUR: true,
    temporalResolveMix: 0.4,
    temporalResolveCorrectionMix: 1.0,
    maxSamples: .1,
    resolutionScale: 1,
    blurMix: 0.4,
    blurExponent: .10,
    blurKernelSize: 10,
    blurSharpness: 10,
    rayStep: 5,
    intensity: 1.0,
    jitter: 1,
    jitterSpread: 0.25,
    jitterRough: 0.1,
    roughnessFadeOut: 1,
    rayFadeOut: 1,
    MAX_STEPS: 5,
    ior: 1.3,

  }
  return (
    enabled && (
      <EffectComposer>
        <Bloom luminanceThreshold={0.4} height={2000} intensity={.10} />
        {/* <SSR {...props} /> */}
        {/* <LUT lut={texture} /> */}
        {/* <DepthOfField /> */}
      </EffectComposer>
    )
  )
}
